export default {
	en: {
		name: "English"
	},
	sr: {
		name: "Srpskohrvatski",
		replacements: ["bs", "hr"]
	}
}